<script>
   import { beforeUpdate, afterUpdate, onMount } from "svelte";
   import { fade } from 'svelte/transition'
   import { gsap } from 'gsap'
   import { ScrollTrigger } from 'gsap/ScrollTrigger'
   gsap.registerPlugin(ScrollTrigger)
   const jq = window.$

   //export
   let testimonials = homeTestimonials
   const { subs, schools } = testimonials
   let switchState = 'subs';
   let activeTestimonials
   $: {
      if(jq('.slick-initialized').length) {
         jq('.slick').slick('unslick')
      }
      activeTestimonials = testimonials[switchState]
   }
   
   afterUpdate(() => {
      jq('.slick').slick({
         adaptiveHeight: true,
         arrows: false,
         dots: true,
         fade: true,
         slidesToShow: 1
      })

      jq('.slick').on('click', function(e){
         jq('.slick').slick('slickNext')
      })
   })

   // onMount(() => {
   //    window.onresize = () => {
   //       if(jq('.slick-initialized').length) {
   //          jq('.slick').slick('unslick')
   //          console.log('re-slick')
   //          jq('.slick').slick({
   //             adaptiveHeight: true,
   //             arrows: false,
   //             dots: true,
   //             fade: true,
   //             slidesToShow: 1
   //          })
   //       }
   //    }
   // })
</script>

<div class="home-hear-from section-full">
   {#if subs.length && schools.length }
   <div class="toggle-main main">
      <div class="inner-wrap">
         <div class="toggle-switch-wrap d-flex justify-content-end align-items-center">
            <form class="toggle-switch">
               <p class="label">Hear from:</p>
               <div class="switch-field">
                  <input type="radio" id="radio-one" name="switch-one" value="subs" checked on:change={() => (switchState = 'subs')} />
                  <label for="radio-one">Subs</label>
                  <input type="radio" id="radio-two" name="switch-one" value="schools" on:change={() => (switchState = 'schools')} />
                  <label for="radio-two">Schools</label>
                  <span class="indicator" />
               </div>
            </form>
         </div>
      </div>
   </div>
   {/if}
   <div class="slick">
      {#each activeTestimonials as t, idx}
         <div class="home-testimonial">
            <div class="main">
               <div class="inner-wrap flex-column flex-lg-row-reverse d-flex">
                  <div class="decor-img cover" style="background-image: url({t.feat_img})" />
                  <div class="test-content _main">
                     <div class="_inner-wrap">
                        <p>"{t.post_content.replace(/\"/g, '')}"</p>
                        <cite>
                           {t.post_title}
                           <br />
                           {t.citation_title}
                        </cite>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      {/each}
   </div>
</div>
